function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VRadioGroup, VRadio } from 'vuetify/lib';
import FormMixin from '../form.mixin';

var ProceduralStepSelection = /*#__PURE__*/function () {
  function ProceduralStepSelection() {
    _classCallCheck(this, ProceduralStepSelection);
  }

  _createClass(ProceduralStepSelection, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-procedural-step-selection', {
        template: "\n        <v-radio-group class=\"dosage-form-selection\" v-bind=\"bind\" v-on=\"$listeners\" @change=\"handleChange\" :rules=\"rules\">\n          <v-radio v-for=\"image in items\" :key=\"image.imageID\" :value=\"image\">\n            <template v-slot:label>\n              <span class=\"dosage-form-selection--button\" :class=\"{'is-active': value === image.imageLabel, 'is-muted': value && value !== image.imageLabel}\"> \n                <svg v-if=\"value === image.imageLabel\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http:.org/2000/svg\">\n                  <circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"currentColor\" />\n                  <path d=\"M8.28571 14.9314L4 10.6457L5.20857 9.43714L8.28571 12.5057L14.7914 6L16 7.21714L8.28571 14.9314Z\"\n                    fill=\"white\" />\n                </svg>\n                <img v-if=\"value === image.imageLabel\" :src=\"image.imageDAMPathActive ? image.imageDAMPathActive : image.imageDAMPath\" :alt=\"image.description\" />\n                <img v-else :src=\"image.imageDAMPath\" :alt=\"image.imageLabel\" />\n              </span>\n              <span class=\"dosage-form-selection--label\" :class=\"{'is-active': value === image.imageLabel, 'is-muted': value && value !== image.imageLabel}\">{{ image.imageLabel }}</span>\n            </template>\n          </v-radio>\n        </v-radio-group>\n      ",
        components: {
          VRadioGroup: VRadioGroup,
          VRadio: VRadio
        },
        mixins: [FormMixin],
        props: {
          items: {
            type: Array,
            "default": function _default() {}
          }
        },
        computed: {},
        methods: {
          handleChange: function handleChange(event) {
            this.$store.commit('forms/SET_DOSAGE_FORM_ID', event.parentId);
            this.$store.state.forms.form.susvimoData = {};
            this.$store.state.forms.form.susvimoSections = [];
            this.$emit('input', event.imageLabel);
          }
        }
      });
    }
  }]);

  return ProceduralStepSelection;
}();

export default ProceduralStepSelection;